import { Badge, Button } from '@e2n/ui/v2';
import { useTranslation } from 'react-i18next';

export function AbgleichFilterLeiste({ anzahl }: { anzahl: number }) {
  const { t } = useTranslation();

  return (
    <div className="flex flex-wrap gap-2">
      <Button
        variant="outline"
        size="small"
        aria-pressed
        className="bg-neutrals-v2-200">
        {t('domain.datev.abgleich.filter.alle')}
        <Badge size="xs" className="bg-neutrals-v2-200 text-labels-primary">
          {anzahl}
        </Badge>
      </Button>
    </div>
  );
}
